define(
    'NMSDesignSystem.PDP.Shopping',
    [
        'ProductDetails.Full.View',
        'ProductDetails.Quantity.View',
        'Cart.AddToCart.Button.View',
        'Item.Model',
        'SC.Configuration',
        'Backbone.View',
        'SocialSharing',
        'NMSDesignSystem.FluReimbursement.Shopping',
        'NMSDesignSystem.StartupData.Shopping',
        'Utils',
        'jQuery',
        'nms_product_details_full.tpl',
        'nms_product_details_image_gallery.tpl',
        'nms_product_details_quantity.tpl',
        'nms_cart_add_to_cart_button.tpl'
    ],
    function NMSDesignSystemPDPShopping(
        ProductDetailsFullView,
        ProductDetailsQuantityView,
        CartAddToCartButtonView,
        ItemModel,
        Configuration,
        BackboneView,
        SocialSharing,
        NMSDesignSystemFluReimbursementShopping,
        NMSDesignSystemStartupDataShopping,
        Utils,
        jQuery,
        nmsProductDetailsFullTemplate,
        nmsProductDetailsImageGalleryTemplate,
        nmsProductDetailsQuantityTemplate,
        nmsCartAddToCartButtonTemplate
    ) {
        'use strict';

        function disablePinterestSharing(application) {
            var layout = application && application.getLayout && application.getLayout();

            if (BackboneView && BackboneView.postRender && BackboneView.postRender.uninstall) {
                BackboneView.postRender.uninstall('pinterestPluginHover');
            }
            if (SocialSharing && SocialSharing.afterAppendView && SocialSharing.afterAppendView.uninstall) {
                SocialSharing.afterAppendView.uninstall('pinterestPlugin');
            }
            if (layout && layout.events) {
                delete layout.events['click [data-action="share-in-pinterest-hover"]'];
                delete layout.events['click [data-action="share-in-pinterest"]'];
            }
            jQuery('[data-action="share-in-pinterest-hover"], [data-action="share-in-pinterest"]').remove();
        }

        function installSingleClickCartButtons() {
            var proto = CartAddToCartButtonView && CartAddToCartButtonView.prototype;
            if (!proto || proto.nmsSingleClickCartButtons) return;
            var originalEvents = proto.events;
            var nativeDisable = proto.disableElementsOnPromise;
            function keepClickEvents(events) {
                var preserved = {};
                var click = 'click [data-type="add-to-cart"]:not([disabled])';
                var mouseup = 'mouseup [data-type="add-to-cart"]:not([disabled])';
                Object.keys(events || {}).forEach(function (key) {
                    if (key !== mouseup || !events[click] || events[key] !== events[click]) {
                        preserved[key] = events[key];
                    }
                });
                return preserved;
            }
            // One pointer gesture must perform one native add. Keep keyboard
            // clicks and every unrelated peer handler, quantity and server check.
            proto.events = typeof originalEvents === 'function' ? function () {
                return keepClickEvents(originalEvents.apply(this, arguments));
            } : keepClickEvents(originalEvents);
            if (typeof nativeDisable === 'function') {
                proto.disableElementsOnPromise = function (promise, target) {
                    var button = target && target.closest && target.closest('[data-type="add-to-cart"]');
                    return nativeDisable.call(this, promise, button || target);
                };
            }
            proto.nmsSingleClickCartButtons = true;
        }

        function getItemValue(view, fieldName) {
            var item = view && view.model && view.model.get && view.model.get('item');

            if (!item) {
                return '';
            }

            return item.get ? item.get(fieldName) : item[fieldName];
        }

        function getPreferredDisplayName(view) {
            return getItemValue(view, 'storedisplayname2') ||
                getItemValue(view, 'displayname') ||
                getItemValue(view, '_name') ||
                getItemValue(view, 'itemid') ||
                '';
        }

        function currentHostname() {
            var environment = typeof SC !== 'undefined' && SC.ENVIRONMENT;

            return String(
                (environment && environment.currentHostString) ||
                (typeof window !== 'undefined' && window.location && window.location.hostname) ||
                ''
            ).toLowerCase();
        }

        function isBuyFluStorefront() {
            var hostname = currentHostname();

            return hostname === 'buyflushots.nmsincusa.com' ||
                hostname === 'buyflu-sandbox.ethanablatt.com';
        }

        function normalizeAvailability(value) {
            return String(value || '').replace(/^\s+|\s+$/g, '').toLowerCase();
        }

        function getProductItem(product) {
            return product && product.getItem
                ? product.getItem()
                : product && product.get && product.get('item');
        }

        function isSoldOutItem(item) {
            var availability = item && item.get
                ? item.get('custitem_availability')
                : item && item.custitem_availability;

            var inStock = item && item.get ? item.get('isinstock') : item && item.isinstock;
            var backorderable = item && item.get ? item.get('isbackorderable') : item && item.isbackorderable;
            var outOfStock = inStock === false || inStock === 'F';
            var noBackorders = backorderable === false || backorderable === 'F';

            // Unknown flags retain native purchase rules; explicit no-stock/no-backorder cannot add.
            return normalizeAvailability(availability) === 'sold out' || (outOfStock && noBackorders);
        }

        // The availability fallback used to start only after the details lookup.
        // Start the same domain/PCV-filtered lookup alongside a normal browser
        // URL route, then use it only after native details succeed and IDs agree.
        function startParallelPdpAvailability(view) {
            if (!isBuyFluStorefront() || typeof window === 'undefined' ||
                    typeof SC === 'undefined' || !SC.ENVIRONMENT || SC.ENVIRONMENT.jsEnvironment !== 'browser' ||
                    !view || !view.arguments || typeof view.arguments[0] !== 'string') return null;
            var slug, current;
            try {
                slug = decodeURIComponent(view.arguments[0]).split('?')[0];
                current = (window.location.hash && window.location.hash.replace(/^#\/?/, '') ||
                    window.location.pathname.replace(/^\//, '')).split('?')[0];
            } catch (error) { return null; }
            // Numeric, matrix, quick-view and unusual routes retain the original
            // native ID-based fallback. Never guess another product's URL.
            if (slug !== current || !/^[A-Za-z0-9][A-Za-z0-9._~-]{0,249}$/.test(slug) || /^\d+$/.test(slug)) return null;
            var early = NMSDesignSystemStartupDataShopping && NMSDesignSystemStartupDataShopping.takePdpAvailability;
            if (typeof early === 'function') {
                var deferred = jQuery.Deferred();
                if (early(window, '/' + slug, function(value) { deferred.resolve(value); })) return deferred.promise();
            }
            var availabilityItem = new ItemModel();
            availabilityItem.searchApiMasterOptions = Configuration.get('searchApiMasterOptions.Facets') || {
                fieldset: 'search', include: 'facets'
            };
            return availabilityItem.fetch({cache: true, data: {url: slug}}).then(function() {
                return {id: availabilityItem.get('internalid'), availability: availabilityItem.get('custitem_availability') || ''};
            }, function() { return null; });
        }

        function finishParallelPdpAvailability(view, pending) {
            if (!pending) return loadPdpAvailability(view);
            return pending.then(function(extra) {
                var item = getProductItem(view && view.model);
                var id = item && item.get && item.get('internalid');
                if (!extra || !id || String(extra.id) !== String(id)) return loadPdpAvailability(view);
                if (!item.get('custitem_availability')) {
                    item.set('custitem_availability', extra.availability, {silent: true});
                    if (view.mainActionViewInstance && view.mainActionViewInstance.render) view.mainActionViewInstance.render();
                }
            });
        }

        function loadPdpAvailability(view) {
            var item = getProductItem(view && view.model);
            var itemId = item && item.get && item.get('internalid');
            var availabilityItem;
            var searchOptions;

            if (!isBuyFluStorefront() || !item || !itemId || item.get('custitem_availability')) {
                return jQuery.Deferred().resolve();
            }

            availabilityItem = new ItemModel();
            searchOptions = Configuration.get('searchApiMasterOptions.Facets') || {
                fieldset: 'search',
                include: 'facets'
            };
            availabilityItem.searchApiMasterOptions = searchOptions;

            return availabilityItem.fetch({
                cache: true,
                data: {id: itemId}
            }).then(function applyAvailability() {
                item.set(
                    'custitem_availability',
                    availabilityItem.get('custitem_availability') || '',
                    {silent: true}
                );

                if (
                    view.mainActionViewInstance &&
                    view.mainActionViewInstance.render
                ) {
                    view.mainActionViewInstance.render();
                }
            });
        }

        function fluReimbursementUrl() {
            var hostname = String(window.location.hostname || '').toLowerCase();

            if (hostname === 'buyflushots.nmsincusa.com' || hostname === 'buyflu-sandbox.ethanablatt.com') {
                return '/flu-vaccine-reimbursement';
            }

            return hostname === 'sca-sandbox.ethanablatt.com'
                ? 'https://buyflu-sandbox.ethanablatt.com/flu-vaccine-reimbursement'
                : 'https://buyflushots.nmsincusa.com/flu-vaccine-reimbursement';
        }

        var activeLightboxTrigger;

        function getFullResolutionImageUrl(source) {
            var url;

            try {
                url = new URL(source, window.location.href);
                url.searchParams.delete('resizeid');
                url.searchParams.delete('resizeh');
                url.searchParams.delete('resizew');
                return url.href;
            } catch (error) {
                return source;
            }
        }

        function prefersReducedMotion() {
            return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        function dismissReimbursementNotice(trigger) {
            var notice = trigger && trigger.closest('.nms-pdp-reimbursement-notice');
            var productTitle = document.getElementById('nms-pdp-title') ||
                document.getElementById('nms-home-vaccine-section-title');
            var finishDismissal;

            if (!notice || notice.classList.contains('nms-pdp-reimbursement-notice--dismissing')) {
                return;
            }

            finishDismissal = function finishReimbursementNoticeDismissal() {
                notice.remove();
                if (productTitle) {
                    productTitle.setAttribute('tabindex', '-1');
                    try {
                        productTitle.focus({preventScroll: true});
                    } catch (error) {
                        productTitle.focus();
                    }
                }
            };

            if (prefersReducedMotion()) {
                finishDismissal();
                return;
            }

            notice.classList.add('nms-pdp-reimbursement-notice--dismissing');
            window.setTimeout(finishDismissal, 240);
        }

        function runProductImageTransition(update) {
            if (document.startViewTransition && !prefersReducedMotion()) {
                return document.startViewTransition(update);
            }

            update();
            return {finished: Promise.resolve()};
        }

        function sizeProductLightboxImage(image, naturalWidth, naturalHeight) {
            var maxWidth = Math.max(0, window.innerWidth - 72);
            var maxHeight = Math.max(0, window.innerHeight - 72);
            var width = Number(naturalWidth) || image.naturalWidth;
            var height = Number(naturalHeight) || image.naturalHeight;
            var scale;

            if (!image || !width || !height || !maxWidth || !maxHeight) {
                return;
            }

            scale = Math.min(maxWidth / width, maxHeight / height);
            image.style.setProperty('width', width * scale + 'px', 'important');
            image.style.setProperty('height', height * scale + 'px', 'important');
        }

        function openProductImageLightbox(trigger) {
            var page = trigger && trigger.closest('.nms-pdp-page');
            // bxSlider prepends a hidden clone. Use the selected original slide,
            // not the first DOM image or a thumbnail, for the full-size view.
            var imageScope = trigger && (trigger.closest('.nms-pdp-lightbox-trigger') || trigger);
            var sourceImage = imageScope && (
                imageScope.querySelector('.product-details-image-gallery-container:not(.bx-clone)[aria-hidden="false"] img') ||
                imageScope.querySelector('.product-details-image-gallery-detailed-image img') ||
                imageScope.querySelector('.product-details-image-gallery-container:not(.bx-clone) img') ||
                imageScope.querySelector('img')
            );
            var lightbox = page && page.querySelector('.nms-pdp-lightbox');
            var lightboxStage = lightbox && lightbox.querySelector('.nms-pdp-lightbox-stage');
            var lightboxImage = lightboxStage && lightboxStage.querySelector('.nms-pdp-lightbox-image');
            var closeButton = lightbox && lightbox.querySelector('.nms-pdp-lightbox-close');
            var transition;

            if (!sourceImage || !lightbox || !lightboxStage || !closeButton) {
                return;
            }

            if (!lightboxImage) {
                lightboxImage = document.createElement('img');
                lightboxImage.className = 'nms-pdp-lightbox-image';
                lightboxStage.appendChild(lightboxImage);
            }

            activeLightboxTrigger = trigger;
            lightboxImage.onload = function resizeLoadedProductImage() {
                sizeProductLightboxImage(lightboxImage);
            };
            lightboxImage.alt = sourceImage.alt || '';
            lightboxImage.src = getFullResolutionImageUrl(sourceImage.currentSrc || sourceImage.src);
            sizeProductLightboxImage(lightboxImage, sourceImage.naturalWidth, sourceImage.naturalHeight);
            transition = runProductImageTransition(function showProductImageLightbox() {
                lightbox.hidden = false;
                lightbox.setAttribute('aria-hidden', 'false');
                trigger.setAttribute('aria-expanded', 'true');
                document.body.classList.add('nms-pdp-lightbox-open');
            });
            function focusProductImageClose() {
                if (!lightbox.hidden) closeButton.focus();
            }
            transition.finished.then(focusProductImageClose, focusProductImageClose);
        }

        function closeProductImageLightbox(animate) {
            var lightbox = document.querySelector('.nms-pdp-lightbox:not([hidden])');
            var trigger = activeLightboxTrigger;
            var transition;
            var hideLightbox = function hideProductImageLightbox() {
                document.body.classList.remove('nms-pdp-lightbox-open');
                lightbox.setAttribute('aria-hidden', 'true');
                lightbox.hidden = true;
                if (trigger) {
                    trigger.setAttribute('aria-expanded', 'false');
                }
            };

            if (!lightbox) {
                document.body.classList.remove('nms-pdp-lightbox-open');
                return;
            }

            transition = animate === false
                ? (hideLightbox(), {finished: Promise.resolve()})
                : runProductImageTransition(hideLightbox);
            function restoreProductImageFocus() {
                if (animate !== false && trigger && document.documentElement.contains(trigger)) {
                    trigger.focus();
                }
                activeLightboxTrigger = null;
            }
            transition.finished.then(restoreProductImageFocus, restoreProductImageFocus);
        }

        function installProductImageLightbox() {
            if (document.__nmsPdpLightboxInstalled) {
                return;
            }

            document.__nmsPdpLightboxInstalled = true;
            document.documentElement.setAttribute('data-nms-pdp-lightbox', 'true');
            document.addEventListener('click', function handleProductImageLightboxClick(event) {
                var reimbursementDismissTrigger = event.target.closest && event.target.closest('[data-action="dismiss-reimbursement-notice"]');
                var openTrigger = event.target.closest && event.target.closest('[data-action="open-product-image-lightbox"]');
                var closeTrigger = event.target.closest && event.target.closest('[data-action="close-product-image-lightbox"]');
                var lightbox = event.target.classList && event.target.classList.contains('nms-pdp-lightbox')
                    ? event.target
                    : null;
                var stage = event.target.classList && event.target.classList.contains('nms-pdp-lightbox-stage')
                    ? event.target
                    : null;

                if (reimbursementDismissTrigger) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    dismissReimbursementNotice(reimbursementDismissTrigger);
                } else if (openTrigger) {
                    // Keep the native carousel and sharing controls operable.
                    // Their handlers must receive the original click unchanged.
                    var galleryControl = event.target.closest && event.target.closest(
                        '.bx-controls, [data-action="next-image"], [data-action="prev-image"], [data-type="social-share-icons-hover"]'
                    );
                    if (galleryControl && openTrigger.contains(galleryControl)) return;
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    openProductImageLightbox(openTrigger);
                } else if (closeTrigger || lightbox || stage) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    closeProductImageLightbox(true);
                }
            }, true);
            var suppressImageEscapeKeyup = false;
            var pendingGallerySpaceArrow;
            document.addEventListener('keydown', function handleProductImageLightboxKeydown(event) {
                var lightbox = document.querySelector('.nms-pdp-lightbox:not([hidden])');

                if (!lightbox) {
                    var arrow = event.target && event.target.closest && event.target.closest(
                        '.nms-pdp-page [data-action="next-image"], .nms-pdp-page [data-action="prev-image"]'
                    );
                    if (arrow && (event.key === 'Enter' || event.key === ' ')) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        // Keep native cancelable before/after image-change events.
                        if (event.key === 'Enter' && !event.repeat) arrow.click();
                        if (event.key === ' ' && !event.repeat) pendingGallerySpaceArrow = arrow;
                    }
                    return;
                }

                if (event.key === 'Escape') {
                    suppressImageEscapeKeyup = true;
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    closeProductImageLightbox(true);
                } else if (event.key === 'Tab') {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    lightbox.querySelector('.nms-pdp-lightbox-close').focus();
                }
            }, true);
            document.addEventListener('keyup', function handleProductImageLightboxKeyup(event) {
                if (event.key === ' ' && pendingGallerySpaceArrow) {
                    var arrow = pendingGallerySpaceArrow;
                    pendingGallerySpaceArrow = null;
                    if (event.target === arrow && document.documentElement.contains(arrow)) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        arrow.click();
                    }
                }
                if (event.key === 'Escape' && suppressImageEscapeKeyup) {
                    suppressImageEscapeKeyup = false;
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            }, true);
            window.addEventListener('hashchange', function closePDPImageOnNavigation() {
                closeProductImageLightbox(false);
            });
            window.addEventListener('resize', function resizeOpenProductImage() {
                var image = document.querySelector('.nms-pdp-lightbox:not([hidden]) .nms-pdp-lightbox-image');

                if (image) {
                    sizeProductLightboxImage(image);
                }
            });
        }

        return {
            mountToApp: function mountToApp(application) {
                installSingleClickCartButtons();
                var prototype = ProductDetailsFullView && ProductDetailsFullView.prototype;
                var quantityPrototype = ProductDetailsQuantityView && ProductDetailsQuantityView.prototype;
                var nativeGetBreadcrumbPages;
                var nativeGetContext;
                var nativeGetTitle;
                var nativeInitialize;
                var nativeBeforeShowContent;
                var nativeRender;
                var nativeImageGallery;
                var childViews;
                var nativeButtonAddToCart;
                var nativeButtonGetContext;

                if (!prototype || prototype.nmsDesignSystemPDPTemplate) {
                    return;
                }

                disablePinterestSharing(application);
                installProductImageLightbox();

                prototype.template = nmsProductDetailsFullTemplate;
                // Only the full NMS PDP uses the fixed 240px gallery. Keep quick-view
                // and other gallery consumers on their native template and behavior.
                if (prototype.childViews && typeof prototype.childViews['Product.ImageGallery'] === 'function') {
                    nativeImageGallery = prototype.childViews['Product.ImageGallery'];
                    childViews = {};
                    Object.keys(prototype.childViews).forEach(function preserveChildView(key) {
                        childViews[key] = prototype.childViews[key];
                    });
                    childViews['Product.ImageGallery'] = function getNMSImageGallery() {
                        var gallery = nativeImageGallery.apply(this, arguments);
                        if (gallery) {
                            gallery.template = nmsProductDetailsImageGalleryTemplate;
                            // NMS already disables hover scaling in source CSS and offers
                            // an accessible full-resolution lightbox instead. Skip the
                            // native hover plugin, which replaces this image with 1200px.
                            gallery.isZoomEnabled = false;
                            if (typeof gallery.initSlider === 'function' && !gallery.nmsAccessibleGalleryArrows) {
                                var nativeInitSlider = gallery.initSlider;
                                gallery.initSlider = function initializeAccessibleNMSGallery() {
                                    var result = nativeInitSlider.apply(this, arguments);
                                    this.$('[data-action="next-image"]').attr({
                                        role: 'button', tabindex: '0', 'aria-label': Utils.translate('Next product image')
                                    });
                                    this.$('[data-action="prev-image"]').attr({
                                        role: 'button', tabindex: '0', 'aria-label': Utils.translate('Previous product image')
                                    });
                                    return result;
                                };
                                gallery.nmsAccessibleGalleryArrows = true;
                            }
                        }
                        return gallery;
                    };
                    prototype.childViews = childViews;
                    // Legacy SCA also caches child definitions on the constructor.
                    if (typeof ProductDetailsFullView.addChildViews === 'function') {
                        ProductDetailsFullView.addChildViews({
                            'Product.ImageGallery': childViews['Product.ImageGallery']
                        });
                    }
                }

                if (quantityPrototype && !quantityPrototype.nmsDesignSystemQuantityTemplate) {
                    quantityPrototype.template = nmsProductDetailsQuantityTemplate;
                    quantityPrototype.nmsDesignSystemQuantityTemplate = true;
                }
                if (
                    CartAddToCartButtonView &&
                    CartAddToCartButtonView.prototype &&
                    !CartAddToCartButtonView.prototype.nmsDesignSystemButtonTemplate
                ) {
                    CartAddToCartButtonView.prototype.template = nmsCartAddToCartButtonTemplate;
                    CartAddToCartButtonView.prototype.nmsDesignSystemButtonTemplate = true;
                }
                if (
                    CartAddToCartButtonView &&
                    CartAddToCartButtonView.prototype &&
                    !CartAddToCartButtonView.prototype.nmsSoldOutGuard
                ) {
                    nativeButtonGetContext = CartAddToCartButtonView.prototype.getContext;
                    CartAddToCartButtonView.prototype.getContext = function getNMSAddToCartContext() {
                        var context = nativeButtonGetContext
                            ? nativeButtonGetContext.apply(this, arguments)
                            : {};
                        var item = getProductItem(this.model);
                        var soldOut = isSoldOutItem(item);

                        context.nmsIsSoldOut = soldOut;
                        context.isCurrentItemPurchasable = !!context.isCurrentItemPurchasable && !soldOut;
                        return context;
                    };

                    nativeButtonAddToCart = CartAddToCartButtonView.prototype.addToCart;
                    CartAddToCartButtonView.prototype.addToCart = function addNMSItemToCart(event) {
                        if (isSoldOutItem(getProductItem(this.model))) {
                            if (event && event.preventDefault) {
                                event.preventDefault();
                            }
                            if (event && event.stopImmediatePropagation) {
                                event.stopImmediatePropagation();
                            }
                            return false;
                        }

                        return nativeButtonAddToCart
                            ? nativeButtonAddToCart.apply(this, arguments)
                            : false;
                    };
                    CartAddToCartButtonView.prototype.nmsSoldOutGuard = true;
                }

                nativeBeforeShowContent = prototype.beforeShowContent;
                prototype.beforeShowContent = function beforeShowNMSProductDetails() {
                    var view = this;
                    var nativeResult = nativeBeforeShowContent
                        ? nativeBeforeShowContent.apply(this, arguments)
                        : jQuery.Deferred().resolve();

                    var pendingAvailability = startParallelPdpAvailability(view);
                    return jQuery.when(nativeResult).then(function loadAvailabilityAfterProduct() {
                        return finishParallelPdpAvailability(view, pendingAvailability);
                    });
                };
                nativeGetBreadcrumbPages = prototype.getBreadcrumbPages;
                prototype.getBreadcrumbPages = function getNMSProductBreadcrumbPages() {
                    var pages = nativeGetBreadcrumbPages ? nativeGetBreadcrumbPages.apply(this, arguments) : [];
                    var nativeDisplayName = getItemValue(this, 'displayname') || getItemValue(this, '_name');
                    var preferredDisplayName = getPreferredDisplayName(this);
                    var hasProducts = pages && pages.some(function hasProductsPage(page) {
                        return page && String(page.href || '').replace(/\/$/, '') === '/products';
                    });

                    pages = (pages || []).map(function usePreferredProductName(page) {
                        if (
                            page &&
                            preferredDisplayName &&
                            nativeDisplayName &&
                            page.text === nativeDisplayName
                        ) {
                            page.text = preferredDisplayName;
                        }

                        return page;
                    });

                    return hasProducts
                        ? pages
                        : [{text: Utils.translate('Products'), href: '/products'}].concat(pages);
                };

                nativeGetContext = prototype.getContext;
                prototype.getContext = function getNMSProductDetailsContext() {
                    var context = nativeGetContext ? nativeGetContext.apply(this, arguments) : {};
                    var item = this && this.model && this.model.get && this.model.get('item');

                    context.nmsProductDisplayName = getPreferredDisplayName(this);
                    context.nmsProductUpc = String(getItemValue(this, 'upccode') || '').trim();
                    context.nmsFluReimbursement = NMSDesignSystemFluReimbursementShopping.getForItem(item);
                    context.nmsFluReimbursementUrl = fluReimbursementUrl();
                    return context;
                };

                nativeRender = prototype.render;
                prototype.render = function renderNMSProductDetails() {
                    var result = nativeRender ? nativeRender.apply(this, arguments) : this;
                    var preferredDisplayName = getPreferredDisplayName(this);

                    if (preferredDisplayName && this.$) {
                        this.$('#nms-pdp-title').text(preferredDisplayName);
                    }

                    return result;
                };

                nativeGetTitle = prototype.getTitle;
                prototype.getTitle = function getNMSProductDetailsTitle() {
                    var title = nativeGetTitle ? nativeGetTitle.apply(this, arguments) : '';
                    var nativeDisplayName = getItemValue(this, 'displayname') || getItemValue(this, '_name');
                    var preferredDisplayName = getPreferredDisplayName(this);

                    if (!preferredDisplayName) {
                        return title;
                    }

                    return nativeDisplayName && title
                        ? String(title).replace(nativeDisplayName, preferredDisplayName)
                        : preferredDisplayName;
                };

				nativeInitialize = prototype.initialize;
				prototype.initialize = function initializeNMSProductDetails() {
					var view = this;
					var result = nativeInitialize && nativeInitialize.apply(this, arguments);
					var instanceGetBreadcrumbPages = prototype.getBreadcrumbPages;

					this.getBreadcrumbPages = function getNMSInstanceBreadcrumbPages() {
						var pages = instanceGetBreadcrumbPages.apply(view, arguments) || [];
						var hasProducts = pages.some(function hasProductsPage(page) {
							return page && String(page.href || '').replace(/\/$/, '') === '/products';
						});

						return hasProducts
							? pages
							: [{text: Utils.translate('Products'), href: '/products'}].concat(pages);
					};

					return result;
				};
                prototype.nmsDesignSystemPDPTemplate = true;
            }
        };
    }
);
